import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, ClassifiedMcc} from '../../../types/data.types';
import {ClassifiedsMccService} from '../../../services/classifieds-mcc.service';
import {DateAdapter} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import {environment} from '../../../../environments/environment';
import { AuthTokenService } from '../../../services/auth-token.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'classifieds-mcc-modal',
    templateUrl: './classifieds-mcc-modal.component.html',
    styleUrls: ['./classifieds-mcc-modal.component.scss']
})
export class ClassifiedsMccModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: ClassifiedMcc = new ClassifiedMcc();
    disabledSubmit = false;
    playlistSelectIsDisabled = true;
    startDate = '';
    expiryDate = '';
    model = {
        buildings: [],
        title: '',
        description: '',
        email: '',
        phone: '',
        name: ''
    };
    playlists = [];
    files = [];
    fileNames = [];
    images = [];
    fileIsOver = false;
    currentImageIndex = 1;
    selectedPlaylist = null;
    multiselectSettings = {
        singleSelection: false,
        text: 'Select Access Level',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        scrollable: true,
        enableSearchFilter: true,
        classes: 'with-filter'
    };
    attachments: Array<any> = [];
    disabledFileInput = false;
    modalSpinnerShow = false;

    constructor(
        public api: ApiClientService,
        public http: Http,
        public classifiedsMccService: ClassifiedsMccService,
        public urlService: UrlService,
        private dateAdapter: DateAdapter<Date>,
        private _sanitizer: DomSanitizer,
        private authTokenService: AuthTokenService
    ) {
        this.dateAdapter.setLocale('en-GB');
    }

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        if (this.classifiedsMccService.classifiedInClassifiedModal) {
            this.data = this.classifiedsMccService.classifiedInClassifiedModal;
            this.model = {
                buildings: (<any>this.data).buildings,
                title: this.data.title,
                description: this.data.content,
                email: this.data.email,
                phone: this.data.phone,
                name: this.data.name
            };
            this.startDate = this.data.activateFrom;
            this.expiryDate = this.data.activateTo;
        } else {

        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.classifiedsMccService.isClassifiedsModalShow = false;
                    this.classifiedsMccService.classifiedInClassifiedModal = null;
                }
            );
        } else {
            this.classifiedsMccService.isClassifiedsModalShow = false;
            this.classifiedsMccService.classifiedInClassifiedModal = null;
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!this.model.title)       toastr.warning('Title should not be blank.');
            if (!this.model.description) toastr.warning('Description should not be blank.');
            if (!this.model.email)       toastr.warning('Email should not be blank.');
            if (!this.model.phone)       toastr.warning('Phone should not be blank.');
            if (!this.model.name)        toastr.warning('Name should not be blank.');
            if (!this.startDate)         toastr.warning('Start should not be blank.');
            if (!this.expiryDate)        toastr.warning('Expiry should not be blank.');
            return;
        }

        const data: any = {
            activateFrom: moment(this.startDate).format('YYYY-MM-DD'),
            activateTo: moment(this.expiryDate).format('YYYY-MM-DD'),
            categoryId: null,
            content: this.model.description,
            email: this.model.email,
            files: this.images.map(f => ({id: f.id})),
            name: this.model.name,
            phone: this.model.phone,
            residentId: null,
            styleAll: null,
            title: this.model.title,
            unitId: null
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainClassifiedsMcc', `classified/${this.data.id}`, data).subscribe(
                () => this.updateView('Classified successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Failed to update classified');
                }
            );
        } else {
            this.api.post('domainClassifiedsMcc', 'classified', data).subscribe(
                () => this.updateView('Classified successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Failed to create classified');
                }
            );
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.classifiedsMccService.getData();
        this.form.reset();
        this.hideModal();
    }

    public showNextImage() {
        if (this.attachments.length > 0 && this.currentImageIndex < this.attachments.length + 1)
            this.currentImageIndex += 1;
    }

    public showPreviousImage() {
        if (this.currentImageIndex > 0)
            this.currentImageIndex -= 1;
    }

    public getBackground() {
        return this._sanitizer.bypassSecurityTrustStyle(`url(${this.attachments[this.currentImageIndex] ? this.attachments[this.currentImageIndex].path : ''})`);
    }

    uploadImage(files) {
        const file = files[0];
        const fd   = new FormData();

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        fd.append('file', file);
        fd.append('folder', 'classifieds');

        const npmiToken = JSON.parse(localStorage.getItem('npmiToken'));
        const token = npmiToken.services.find(s => s.name == 'domainClassifiedsMcc').response.token;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainClassifiedsMcc}file`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                this.files.push(res);
                if (this.images.length === 0)
                    this.currentImageIndex = 0;
                this.images.push(res.path);
                const input = document.getElementById('fileInput');
                if(input)
                    (<any>input).value = '';
            },
            error => {
                toastr.error('Upload file failed');
            }
        );
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd   = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 10000000) {
            toastr.warning('Maximum attachment size is 10MB.');
            return;
        }
        if (this.attachments.length >= 20 ) {
            toastr.warning('You can upload only up to 20 images.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token   = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.modalSpinnerShow = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainServiceRequest}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) { toastr.warning('Attachment path should not be blank.'); return; }
                const attachment = {name: file.name, path: res.path};
                this.attachments.push(attachment);
                this.modalSpinnerShow = false;
                this.disabledFileInput = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.modalSpinnerShow = false;
                this.disabledFileInput = false;
            }
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/classifieds-mcc/classifieds-mcc-modal/classifieds-mcc-modal.component.ts